export const REPORT_STATE_SELECTOR = "reportGeo";
export const REPORT_COLUMNS_KEY = "[REPORT ==> geo] Visible columns is:";
export const REPORT_DATE_KEY = "[REPORT ==> geo] Date range is: ";
